import React from 'react';

import Stack from '@mui/material/Stack';
import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';

import Avatar from '@/components/mui/Avatar';
import type { DialogUser } from '@/pages/common/Dialog/components/EmailTag';

interface UserOptionLabelProps {
  tag: string;
  users: Record<string, DialogUser>;
}

const UserOptionLabel: React.FC<UserOptionLabelProps> = ({ tag, users }) => {
  const user = users[tag];

  return (
    <Stack direction="row" alignItems="center" gap={1}>
      <Box>
        <Avatar name={user?.username || tag} src={user?.picture} />
      </Box>
      <Box>
        <Typography variant="body2">{user ? `${user.username} (${tag})` : tag}</Typography>
      </Box>
    </Stack>
  );
};

export default UserOptionLabel;
